module.exports = __webpack_public_path__ + "static/media/bawl.5c0e7ab8.png";